<section class="cyclops testimonial position-relative" [ngStyle]="{'background-image': 'url(assets/images/header2.jpeg)'}">
  <!-- Overlay dark -->
  <div class="overlay-dark"></div>

  <div class="container position-relative">
    <div class="row">
      <div class="col-12">
        <div class="title text-center">
          <div class="main-title">
            <h2 class="text-white">Who We Serve</h2>
          </div>
        </div>
      </div>
      <div class="col-lg-8 offset-lg-2">
        <owl-carousel-o [options]="testimonialCarouselOptions" class="testimonial-slider">
          <ng-container *ngFor="let user of users">
            <ng-template carouselSlide class="item">
              <div>
                <img [src]="user.img" alt="" class="img-fluid m-auto">
                <div class="text-center testimonial-info">
                 <p class="p-light testimonial-para text-white" [innerHTML]="user.testimonial"></p>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </div>
</section>
